var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37,41c0,1.6542969-1.3457031,3-3,3H14c-1.6542969,0-3-1.3457031-3-3V12H9v29c0,2.7568359,2.2431641,5,5,5h20 c2.7568359,0,5-2.2431641,5-5V12h-2V41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,8V5c0-1.6542969-1.3457031-3-3-3H19c-1.6542969,0-3,1.3457031-3,3v3H7v2h9h16h9V8H32z M30,8H18V5 c0-0.5517578,0.4482422-1,1-1h10c0.5517578,0,1,0.4482422,1,1V8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 2,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 12,
    width: 2,
    height: 26
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteMedium);
export default __webpack_public_path__ + "static/media/delete--medium.973916c33c885e2084534cc92ded31a8.svg";
export { ForwardRef as ReactComponent };